import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import "@fontsource/work-sans";
import * as Sentry from "@sentry/react";
import { scrubBreadcrumb } from "./utils/sentry.ts";
import { rememberFirstTouch } from "./utils/firstTouch.ts";

rememberFirstTouch();

Sentry.init({
  dsn: "https://c04b07f10f5851530459549f8f0a34bc@o4508916129071104.ingest.us.sentry.io/4509340433711104",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  beforeBreadcrumb: scrubBreadcrumb,
  _experiments: { enableLogs: true },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
